import axios from 'axios';
import { API_URL } from 'constants/config';
import ls from 'localstorage-slim';
import Log from 'lib/Log';
// enable global encryption
ls.config.encrypt = true;

export const saveDynamicRegistrationFlow = async (payload) => {
  try {
    const headers = {
      headers: {
        Authorization: `Bearer ${ls.get('token')}`,
        organisationid: ls.get('orgId'),
      },
    };

    return await axios.post(`${API_URL}/admin/apprenticeship-program/apprenticeship-registration-flow/create`, payload, headers);
  } catch (err) {
    throw err.response?.data || err;
  }
};

export const updateDynamicRegistrationFlow = async (payload) => {
  try {
    const headers = {
      headers: {
        Authorization: `Bearer ${ls.get('token')}`,
        organisationid: ls.get('orgId'),
      },
    };

    return await axios.post(`${API_URL}/admin/apprenticeship-program/apprenticeship-registration-flow/update/title`, payload, headers);
  } catch (err) {
    throw err.response?.data || err;
  }
};

export const getDynamicRegistrationFlowList = async (payload) => {
  const headers = {
    Authorization: `Bearer ${ls.get('token') || payload?.token}`,
    organisationid: ls.get('orgId') || payload.orgId,
  };
  const query = {
    search: payload.search_keyword ? payload.search_keyword : '',
    sort: payload.sort,
    sortBy: payload.sortBy,
    currentPage: payload.currentPage,
    perPage: payload.perPage,
  };
  try {
    return await axios.get(
      `${API_URL}/admin/apprenticeship-program/apprenticeship-registration-flow/list
`,
      { params: query, headers },
    );
  } catch (err) {
    throw new Error(err);
  }
};

export const deleteDynamicRegistrationFlow = async ({ orgId, id }) => {
  try {
    const headers = {
      Authorization: `Bearer ${ls.get('token')}`,
      organisationid: ls.get('orgId') || orgId,
    };
    return await axios.delete(`${API_URL}/admin/apprenticeship-program/apprenticeship-registration-flow/${id}/delete`, { headers });
  } catch (err) {
    Log.error('Error >> ', err);
    throw err.response?.data || err;
  }
};

// api to add dynamic field on a specific registration flow
export const addDynamicFieldToRegistrationFlow = async (payload) => {
  try {
    const headers = {
      headers: {
        Authorization: `Bearer ${ls.get('token')}`,
        organisationid: ls.get('orgId'),
      },
    };

    return await axios.post(`${API_URL}/admin/apprenticeship-program/apprenticeship-registration-flow/update`, payload, headers);
  } catch (err) {
    throw err.response?.data || err;
  }
};

// api to get flow list by id

export const getDynamicRegistrationFlowByListId = async (payload) => {
  const headers = {
    Authorization: `Bearer ${ls.get('token') || payload?.token}`,
    organisationid: ls.get('orgId') || payload.orgId,
  };

  try {
    return await axios.get(`${API_URL}/admin/apprenticeship-program/apprenticeship-registration-flow/${payload.id}`, { headers });
  } catch (err) {
    throw new Error(err);
  }
};

export const getDynamicRegistrationFlowRegisterUrl = async (payload) => {
  const headers = {
    Authorization: `Bearer ${ls.get('token') || payload?.token}`,
    organisationid: ls.get('orgId') || payload.orgId,
  };

  try {
    return await axios.get(`${API_URL}/admin/apprenticeship-program/apprenticeship-registration-flow/${payload.id}/register-url`, { headers });
  } catch (err) {
    throw err.response?.data || err;
  }
};

export const deleteRegistrationFlowField = async (payload) => {
  try {
    const headers = {
      headers: {
        Authorization: `Bearer ${ls.get('token')}`,
        organisationid: ls.get('orgId'),
      },
    };

    return await axios.post(`${API_URL}/admin/apprenticeship-program/remove/apprenticeship-registration-flow-steps`, payload, headers);
  } catch (err) {
    throw err.response?.data || err;
  }
};

export const dragAndDropRegistrationFlowField = async (payload) => {
  try {
    const headers = {
      headers: {
        Authorization: `Bearer ${ls.get('token')}`,
        organisationid: ls.get('orgId'),
      },
    };

    return await axios.post(`${API_URL}/admin/apprenticeship-program/order/apprenticeship-registration-flow`, payload, headers);
  } catch (err) {
    throw err.response?.data || err;
  }
};
